import { h } from 'preact';
import ProductCardShopTheLook from 'utils/product-card-shop-the-look';
import { useEffect, useState } from 'preact/hooks';
import { FreeMode, Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import ChevronRightIcon from 'utils/icon/icon-chevron-right.svg';
import clsx from 'clsx';
import * as queries from 'utils/storefront/queries';
import Storefront from 'utils/storefront';
import { edgesToNodes } from 'utils/storefront/format-resource';
// import ShopTheLookCard from './shop-the-look-card';

const ProductShopTheLook = (props) => {
  const title = props.shopTheLook?.title || '';
  const buttonLabel = props.shopTheLook?.buttonLabel || '';
  const buttonURL = props.shopTheLook?.buttonURL || '';
  const { currentProduct } = props;
  const [products, setProducts] = useState(
    props.shopTheLook?.products.filter((product) => product.id) || [],
  );

  useEffect(() => {
    if (currentProduct.modelWearing?.value) {
      const productIds = JSON.parse(currentProduct.modelWearing.value);
      const storefront = Storefront.getInstance();
      const getProducts = async (ids) => {
        const response = await storefront.request({
          query: queries.getProductsByIds,
          variables: {
            ids,
          },
        });
        if (!response.data) {
          // eslint-disable-next-line no-console
          console.error(
            'product/product-shop-the-look.js: Storefront API request failed',
            response,
          );
          return [];
        }
        return edgesToNodes(
          response.data.nodes.filter((i) => i),
          'product',
        );
      };
      getProducts(productIds).then((data) => setProducts(data));
    } else {
      setProducts([]);
    }
  }, [currentProduct]);

  return (
    products.length > 0 && (
      <div className={`my-16 mt-32 lc:lg:my-20 lc:lg:mt-36`}>
        <div className="lc:body-1 ml:display-4 lc:mb-8 ml:mb-16 ml:text-center">
          {title}
        </div>
        <div
          id="shop-the-look-grid"
          className="-mx-24 max-w-container md:mx-auto grid grid-cols-2 lc:gap-8 ml:gap-4 model-wearing-grid"
        >
          {products.slice(0, 4).map((productItem) => (
            <ProductCardShopTheLook
              key={productItem.id}
              productItem={productItem}
              {...props}
            />
          ))}
        </div>
        <div className="relative ab-test-kan58  model-wearing-slider below-768:-mx-24 -mr-24">
              <div
                className={clsx(
                  'hidden md:flex absolute bottom-full right-0 lc:pt-2 mr-12',
                  {
                    'mb-12': !!title,
                    'mb-11 ml:mb-2': !title,
                  },
                )}
              >
                <button className="prev w-32 h-32 rounded-full lc:border border-grey-900 flex justify-center items-center mx-4 lc:mx-8 pr-2">
                  <ChevronRightIcon className="w-16 ml:w-24 h-auto rotate-180" />
                </button>
                <button className="next w-32 h-32 rounded-full lc:border border-grey-900 flex justify-center items-center pl-2">
                  <ChevronRightIcon className="w-16 ml:w-24 h-auto" />
                </button>
              </div>
              <Swiper
                 modules={[Navigation, FreeMode]}
                 className={clsx('max-w-container mx-auto', {
                   'ml:md:[&_.swiper-wrapper]:justify-center-null': products.length < 4,
                 })}
                 navigation={{
                  prevEl: `.model-wearing-slider .prev`,
                  nextEl: `.model-wearing-slider .next`,
                  disabledClass: 'text-disabled !border-grey-400',
                }}
                 slidesPerView={'auto'}
                 freeMode={true}
                 observer={true}
                 spaceBetween={8}
              >
                {products.slice(0, 4).map((card) => (
                  <SwiperSlide
                    key={card.id}
                    className='!w-[247px] md:!w-[calc((100%_-_50px)/2)] below-768:!w-[calc((100%_-_50px)/2)]'
                  >
                  <ProductCardShopTheLook
                    key={card.id}
                    productItem={card}
                  {...props}
                  />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
        <a
          className="block body-3-underline hover:no-underline mt-24 ml:text-center"
          href={buttonURL}
        >
          {buttonLabel}
        </a>
      </div>
    )
  );
};

export default ProductShopTheLook;
